function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { createBaseComponent } from '@semcore/core';
import Icon from '../../lib/esm/index.mjs';
function RootChevronRight({
  width = '24',
  height = '24',
  viewBox = '0 0 24 24',
  ...props
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    "data-name": "ChevronRight",
    "data-group": "l",
    width: width,
    height: height,
    viewBox: viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.293 20.707a1 1 0 0 1 0-1.414L14.586 12 7.293 4.707a1 1 0 0 1 1.414-1.414l8 8a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0Z",
    shapeRendering: "geometricPrecision"
  }));
}
RootChevronRight.displayName = 'ChevronRight';
const ChevronRight = createBaseComponent(RootChevronRight);
export { ChevronRight as default };